import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  UmmsOverviewParams,
  UmmsResponse,
} from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  iipService: IipServiceRequest;
  params: UmmsOverviewParams;
  onError?: (error: unknown) => unknown;
};

type RequestOptions = {
  url: string;
  params: UmmsOverviewParams;
};

export function useUmms({ iipService, params, onError }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestOptions) => {
      return axios.request<UmmsResponse>({
        ...baseConfig,
        url: urlTemplate.parse(url).expand({}),
        params,
      });
    },
    {
      neededOnPageLoad: true,
      onError,
    }
  );

  useEffect(() => {
    if (!iipService.response) return;

    request.execute({
      url: iipService.response.data._links.umms.href,
      params,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [iipService.response, params]);

  return request;
}

export type UmmsRequest = ReturnType<typeof useUmms>;
